import { RoutePath } from "#src/utils/route";
import { UserGroupsRoutePath } from "../..";

export const UserGroupEditRoutePath = UserGroupsRoutePath.concat(
  new RoutePath<"groupId">({
    path: "/:groupId/edit",
    title: "Edit User Group",
  })
);
